function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var _dec, _class;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/react';
import shouldRender from './shouldRender';
import Hammer from 'hammerjs';
import close from './close.png';
var Popup = (_dec = shouldRender(), _dec(_class = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Popup, _React$PureComponent);

  var _super = _createSuper(Popup);

  function Popup() {
    var _this;

    _classCallCheck(this, Popup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.setScroll = function () {
      var isOpen = _this.props.isOpen;

      if (isOpen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'auto';
      }
    };

    _this.renderMask = function () {
      var _this$props = _this.props,
          _this$props$mask = _this$props.mask,
          mask = _this$props$mask === void 0 ? true : _this$props$mask,
          isOpen = _this$props.isOpen,
          onMaskClick = _this$props.onMaskClick,
          _this$props$maskColor = _this$props.maskColor,
          maskColor = _this$props$maskColor === void 0 ? 'rgba(0, 0, 0, 0.5)' : _this$props$maskColor,
          isRender = _this$props.isRender;
      if (!mask || !isRender) return null;
      return jsx("div", {
        onClick: onMaskClick,
        ref: function ref(me) {
          return _this.mask = me;
        },
        css: {
          position: 'fixed',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          background: maskColor,
          opacity: isOpen ? 1 : 0,
          transition: 'opacity 0.3s ease-in-out',
          zIndex: 4401,
          overscrollBehavior: 'contain'
        }
      });
    };

    _this.positionCss = function () {
      var _this$props2 = _this.props,
          isOpen = _this$props2.isOpen,
          _this$props2$position = _this$props2.position,
          position = _this$props2$position === void 0 ? 'bottom' : _this$props2$position,
          _this$props2$borderRa = _this$props2.borderRadius,
          borderRadius = _this$props2$borderRa === void 0 ? 5 : _this$props2$borderRa;

      if (position === 'left') {
        return {
          bottom: 0,
          left: 0,
          top: 0,
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)'
        };
      } else if (position === 'right') {
        return {
          bottom: 0,
          right: 0,
          top: 0,
          transform: isOpen ? 'translateX(0)' : 'translateX(100%)'
        };
      } else if (position === 'top') {
        return {
          top: 0,
          left: 0,
          right: 0,
          transform: isOpen ? 'translateY(0)' : 'translateY(-100%)'
        };
      } else {
        return {
          bottom: 0,
          left: 0,
          right: 0,
          transform: isOpen ? 'translateY(0)' : 'translateY(100%)',
          borderTopLeftRadius: borderRadius,
          borderTopRightRadius: borderRadius
        };
      }
    };

    _this.renderTitle = function () {
      var _this$props3 = _this.props,
          title = _this$props3.title,
          onClose = _this$props3.onClose;
      if (!title) return null;
      return jsx(React.Fragment, null, jsx("div", {
        css: {
          height: 50,
          color: '#1a1a1a',
          fontSize: 15,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }
      }, jsx("div", {
        css: {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          flex: 1,
          marginLeft: 15
        }
      }, title), jsx("div", {
        onClick: onClose,
        css: {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          cursor: 'pointer',
          width: 46
        }
      }, jsx("img", {
        css: {
          width: 16,
          height: 16
        },
        src: close,
        alt: ""
      }))), jsx("div", {
        css: {
          margin: '0 15px',
          borderBottom: '1px solid #efefef'
        }
      }));
    };

    _this.onClickWp = function (e) {
      e.preventDefault();
      e.stopPropagation();
    };

    return _this;
  }

  _createClass(Popup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.createHammer();
      this.setScroll();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var isOpen = this.props.isOpen;
      var prevIsOpen = prevProps.isOpen;

      if (isOpen !== prevIsOpen) {
        this.setScroll();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.body.style.overflow = 'auto';
    }
  }, {
    key: "createHammer",
    value: function createHammer() {
      var onClose = this.props.onClose;
      var mc = new Hammer.Manager(this.container);
      mc.add(new Hammer.Swipe());
      mc.get('swipe').set({
        direction: Hammer.DIRECTION_ALL
      });
      var _this$props$position = this.props.position,
          position = _this$props$position === void 0 ? 'bottom' : _this$props$position;

      if (position === 'left') {
        mc.on('swipeleft', onClose);
      } else if (position === 'right') {
        mc.on('swiperight', onClose);
      } else if (position === 'top') {
        mc.on('swipeup', onClose);
      } else {
        mc.on('swipedown', onClose);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          children = _this$props4.children,
          className = _this$props4.className,
          style = _this$props4.style;
      return jsx(React.Fragment, null, this.renderMask(), jsx("div", {
        onClick: this.onClickWp,
        ref: function ref(me) {
          return _this2.container = me;
        },
        css: _objectSpread({
          position: 'fixed',
          transition: 'transform 0.3s ease-in-out',
          zIndex: 4401,
          background: '#fff'
        }, this.positionCss()),
        className: className,
        style: style
      }, this.renderTitle(), children));
    }
  }]);

  return Popup;
}(React.PureComponent)) || _class);
export default Popup;